import React, { useState } from "react";
import {
  FaStar,
  FaQrcode,
  FaCreditCard,
  FaRobot,
  FaPlay,
  FaBars,
  FaSignInAlt,
  FaUser,
} from "react-icons/fa";
import Header from "./LayoutIntro/Header";
import Hero from "./introComponent/Hero";
import FeatureBlock from "./introComponent/FeatureBlock";
import MarketingPlatformSection from "./introComponent/MarketingSection";
import Sidebar from "./LayoutIntro/Sidebar";
import PartnerSection from "./introComponent/PartnerSection";
import SignUpBanner from "./introComponent/SignUpBanner";
import { BusinessFeaturesSection } from "./introComponent/BusinessFeature";
import CourseCategorySection from "./introComponent/CategorySection";
import FooterIntro from "./LayoutIntro/FooterIntro";
import BrowseByCity from "./introComponent/Browsebycity";

const BusinessIntroPage = () => {
  return (
    <>
      <Hero />
      <FeatureBlock />
      <MarketingPlatformSection />
      <PartnerSection />
      <SignUpBanner />
      <BusinessFeaturesSection />
      <CourseCategorySection />
    </>
  );
};

export default BusinessIntroPage;
